import React from "react"

import styles from "./feature_grid.module.scss"

const FeaturesGridComponent = ({ title, subtitle, features, threeItems, left, page }) => (
  <div className={`container ${styles.container}`}>
    <div className={styles.header}>
      <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: title }}></h2>
      <div className={styles.subtitle} dangerouslySetInnerHTML={{ __html: subtitle }}></div>
    </div>
    <div className={`${threeItems ? styles.threeItems : styles.grid} ${title ? styles.offsetTop : ''}`}>
      {features.map(feature =>
        <div key={feature.name} className={`${styles.feature} ${left ? styles.left : ''}`}>
          <div className={styles.featureImage}>
            <img className={`${page === 'notifications' ? styles.notifications : ''}`} src={feature.image} alt={feature.name} />
          </div>
          <div className={`${page === 'notifications' ? styles.notifications : ''} ${styles.featureDescription}`}>
            <h3 className={styles.featureName}>{feature.name}</h3>
            <div className={styles.featureText}>{feature.text}</div>
          </div>
        </div>,
      )}
    </div>
  </div>
)

export default FeaturesGridComponent